import { render, staticRenderFns } from "./AlertPolicy.vue?vue&type=template&id=dcbb973e&"
import script from "./AlertPolicy.vue?vue&type=script&lang=js&"
export * from "./AlertPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports